import { SendEmail, SendPush, SendSMS } from 'ui/icons';
import { ChannelType, ChannelNodeTypeMap } from 'modules/workflows/constants';
import { ChannelOption } from './types';

export const editorId = 'channel-opt-editor';
export const channelSelectOptionsId = 'channel-select-option';

const createOption = (
  channelType: ChannelType,
  { text, icon }: Pick<ChannelOption, 'text' | 'icon'>,
) => {
  const nodeType = ChannelNodeTypeMap[channelType];
  return { icon, text, isChecked: false, id: `${nodeType}-channel`, nodeType, channelType };
};

export const channelOptions: ChannelOption[] = [
  createOption(ChannelType.Email, { text: 'Email', icon: SendEmail }),
  createOption(ChannelType.Push, { text: 'Push', icon: SendPush }),
  createOption(ChannelType.SMS, { text: 'SMS', icon: SendSMS }),
];
